module.exports = "https://cdn.littlereply.com/tt/resource/lh_toast_failure.22a6a964f6d253ae579575970fce3582.png";